import React from "react";

function Booking() {
  return (
    <>
      <div className="booking-alert">
        <p>
          📢 <strong>बुकिंग चालू!</strong> 💥 सिर्फ आज – 1 जोड़ी 2 पत्ती फिक्स
          🎯
        </p>
        <p>
          <strong>₹2500/-</strong> में लाखों कमाने का मौका – मनी बैक गारंटी!
        </p>
      </div>
    </>
  );
}

export default Booking;
